import { Popover as PopoverPrimitive } from "@base-ui/react/popover";
import * as React from "react";

import { cn } from "@/lib/utils";

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverContent = React.forwardRef<
	HTMLDivElement,
	React.ComponentPropsWithoutRef<"div"> & {
		align?: "start" | "center" | "end";
		sideOffset?: number;
		side?: "top" | "right" | "bottom" | "left";
	}
>(({ className, align = "center", sideOffset = 4, side, ...props }, ref) => (
	<PopoverPrimitive.Portal>
		<PopoverPrimitive.Positioner
			className="z-[99]"
			sideOffset={sideOffset}
			align={align}
			side={side}
		>
			<PopoverPrimitive.Popup
				ref={ref}
				className={cn(
					"w-72 rounded-md border bg-popover p-4 text-popover-foreground outline-none data-[open]:animate-in data-[closed]:animate-out data-[closed]:fade-out-0 data-[open]:fade-in-0 data-[closed]:zoom-out-95 data-[open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
					className,
				)}
				{...props}
			/>
		</PopoverPrimitive.Positioner>
	</PopoverPrimitive.Portal>
));
PopoverContent.displayName = "PopoverContent";

export { Popover, PopoverTrigger, PopoverContent };
